import React from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchRounded from '@mui/icons-material/SearchRounded'
import CloseRounded from '@mui/icons-material/CloseRounded'

type Props = Partial<React.ComponentProps<typeof TextField>> & {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
}

const SearchInput: React.FC<Props> = ({ value, setValue, ...rest }) => {
  const [shrink, setShrink] = React.useState(!!value)
  return (
    <TextField
      label="Digite para pesquisar"
      onFocus={() => setShrink(true)}
      onBlur={(e) => setShrink(!!e.target.value)}
      sx={{ maxWidth: '41.25rem', width: '100%', "& .MuiOutlinedInput-notchedOutline": { px: 5.5 } }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      slotProps={{
        inputLabel: { sx: { ml: 4.5 }, shrink },
        htmlInput: { maxLength: 255 },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchRounded />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end" sx={{ cursor: 'pointer' }} onClick={() => setValue('')}>
              <CloseRounded />
            </InputAdornment>
          ) : null
        }
      }}
      variant="outlined"
      {...rest}
    />
  )
}

export default SearchInput
